import { useT } from '@/lib/useLang';

/**
 * Le positionnement en une phrase, sorti de l'étape 4 de « How it works » où il
 * était enterré : NeverZero ne vend pas de la viralité, il vend un départ.
 */
export function Positioning() {
  const t = useT();

  return (
    <section className="nz-promise">
      <h2 className="nz-h2">
        {t.promiseH2a}
        <br />
        <span>{t.promiseH2b}</span>
      </h2>
      <p className="nz-lead">{t.promiseP}</p>
    </section>
  );
}
